import React from "react";

export const Team = (props) => {
  return (
    <div className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Rencontrez l’équipe</h2>
          <p>
            Rencontrez notre équipe de professionnels passionnés et dévoués. Chaque membre apporte son expertise et sa créativité pour garantir le succès de vos projets. Nous croyons en la collaboration et l'innovation pour offrir des solutions uniques et efficaces.
          </p>
        </div>

        {/* Centering the team members */}
        <div className="team_cont d-flex flex-wrap justify-content-center">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
                  <div className="thumbnail">
                    <img src={d.img} alt="..." className="team-img"/>
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>

      </div>
    </div>
  );
};
